import { h } from 'preact'
import Icon from '../../preact-components/assets'
interface Props {
  customClass?: string
  width?: number
  height?: number
  color?: string
}

export const LoadingSpinner = ({ customClass, width, height, color }: Props) => (
  <div className='loader-container'>
    <Icon icon='loadingSpinner' width={width} height={height} color={color} customClass={`${customClass ?? ''} icon-loading-spinner`} />
  </div>
)
